import { Notification, NotificationTypes } from "services/types/notifications";

/**
 * Whether this bell row is a Sales Coach "Sales review ready" notification.
 *
 * The backend has no notification type of its own for these — they reuse
 * `NotificationType.AMBIENT_SCRIBE` (8) alongside "Scribe generated", "Summary
 * generated", "Insights generated" and "Visit summary letter ready", so `type` alone
 * cannot tell them apart. `extra.review_id` can: the sales-review sender is the only
 * one of the five that writes it (`communication/consumers/clinic.py`).
 *
 * Two details are load-bearing:
 *
 * - **`type` is checked first.** `Notification` is a discriminated union and
 *   `AppointmentNotification` has no `extra` property at all, so reading `extra` off
 *   the un-narrowed union does not typecheck. There is no typecheck gate in this repo
 *   (see the root CLAUDE.md), so that would have shipped silently.
 * - **The `?.` is deliberate.** `Notification.extra` is `JSONField(null=True)` on the
 *   backend, so `null` is reachable at runtime even though our type declares the
 *   object as always present.
 */
export const isSalesReviewNotification = (
  notification: Notification
): boolean =>
  notification.type === NotificationTypes.AMBIENT_SCRIBE &&
  notification.extra?.review_id != null;
